/**
 * @generated SignedSource<<37a6e9bf359fdd26962323516450a562>>
 * @relayHash 776cbc8f0b03c2bd6dd679d1c0f43fd6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0c7fed0f55d7c7a558f04463a5b6ab21494ed602ead3e9325a3632f2ba811087

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraAgentSessionState = "ARTEFACT_READY" | "AUTH_REQUIRED" | "CANCELLED" | "COMPLETED" | "FAILED" | "INPUT_REQUIRED" | "LOADING" | "REJECTED" | "UNKNOWN" | "WORKING" | "%future added value";
export type JiraBulkEditMultiSelectFieldOptions = "ADD" | "REMOVE" | "REMOVE_ALL" | "REPLACE" | "%future added value";
export type JiraBulkLinkEditOperation = "ADD" | "REMOVE_ALL" | "REPLACE_ALL" | "%future added value";
export type JiraIssueLinkDirection = "BOTH" | "INWARD" | "OUTWARD" | "%future added value";
export type JiraProjectInput = {
  id?: string | null;
  projectId: string;
};
export type JiraIssueTypeInput = {
  id?: string | null;
  issueTypeId: string;
};
export type JiraRequestTypeInput = {
  key: string;
};
export type JiraIssueFieldsInput = {
  affectedServicesField?: JiraAffectedServicesFieldInput | null;
  agentSessions?: ReadonlyArray<JiraIssueCreateAgentSessionInput> | null;
  assetsField?: JiraAssetFieldInput | null;
  atlassianTeamFields?: ReadonlyArray<JiraAtlassianTeamFieldInput> | null;
  cascadingSelectFields?: ReadonlyArray<JiraCascadingSelectFieldInput> | null;
  clearableNumberFields?: ReadonlyArray<JiraClearableNumberFieldInput> | null;
  cmdbFields?: ReadonlyArray<JiraCMDBFieldInput> | null;
  colorFields?: ReadonlyArray<JiraColorFieldInput> | null;
  datePickerFields?: ReadonlyArray<JiraDateFieldInput> | null;
  dateTimePickerFields?: ReadonlyArray<JiraDateTimeFieldInput> | null;
  entitlementField?: JiraEntitlementFieldInput | null;
  epicLinkField?: JiraEpicLinkFieldInput | null;
  issueLinks?: JiraIssueLinksFieldInput | null;
  issueType?: JiraIssueTypeInput | null;
  jiraForgeGroupsFields?: ReadonlyArray<JiraForgeGroupsFieldInput> | null;
  jiraForgeStringsFields?: ReadonlyArray<JiraForgeStringsFieldInput> | null;
  jiraForgeUsersFields?: ReadonlyArray<JiraForgeUsersFieldInput> | null;
  labelsFields?: ReadonlyArray<JiraLabelsFieldInput> | null;
  longTextFields?: ReadonlyArray<JiraSingleLineTextFieldInput> | null;
  multipleGroupPickerFields?: ReadonlyArray<JiraMultipleGroupPickerFieldInput> | null;
  multipleSelectClearableUserPickerFields?: ReadonlyArray<JiraMultipleSelectClearableUserPickerFieldInput> | null;
  multipleSelectFields?: ReadonlyArray<JiraMultipleSelectFieldInput> | null;
  multipleSelectUserPickerFields?: ReadonlyArray<JiraMultipleSelectUserPickerFieldInput> | null;
  multipleVersionPickerFields?: ReadonlyArray<JiraMultipleVersionPickerFieldInput> | null;
  multiselectComponents?: JiraMultiSelectComponentFieldInput | null;
  numberFields?: ReadonlyArray<JiraNumberFieldInput> | null;
  organizationField?: JiraOrganizationFieldInput | null;
  originalEstimateField?: JiraDurationFieldInput | null;
  parentField?: JiraParentFieldInput | null;
  peopleFields?: ReadonlyArray<JiraPeopleFieldInput> | null;
  priority?: JiraPriorityInput | null;
  projectFields?: ReadonlyArray<JiraProjectFieldInput> | null;
  resolution?: JiraResolutionInput | null;
  respondersField?: JiraServiceManagementRespondersFieldInput | null;
  richTextFields?: ReadonlyArray<JiraRichTextFieldInput> | null;
  security?: JiraSecurityLevelInput | null;
  singleGroupPickerFields?: ReadonlyArray<JiraSingleGroupPickerFieldInput> | null;
  singleLineTextFields?: ReadonlyArray<JiraSingleLineTextFieldInput> | null;
  singleOrganizationField?: JiraSingleOrganizationFieldInput | null;
  singleSelectClearableUserPickerFields?: ReadonlyArray<JiraUserFieldInput> | null;
  singleSelectFields?: ReadonlyArray<JiraSingleSelectFieldInput> | null;
  singleSelectUserPickerFields?: ReadonlyArray<JiraSingleSelectUserPickerFieldInput> | null;
  singleVersionPickerFields?: ReadonlyArray<JiraSingleVersionPickerFieldInput> | null;
  sprintsField?: JiraSprintFieldInput | null;
  status?: JiraStatusInput | null;
  teamFields?: ReadonlyArray<JiraTeamFieldInput> | null;
  timeTrackingField?: JiraTimeTrackingFieldInput | null;
  urlFields?: ReadonlyArray<JiraUrlFieldInput> | null;
};
export type JiraAffectedServicesFieldInput = {
  affectedServices: ReadonlyArray<JiraAffectedServicesInput>;
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null;
  fieldId: string;
};
export type JiraAffectedServicesInput = {
  serviceId: string;
};
export type JiraIssueCreateAgentSessionInput = {
  agentSessionId: string;
  convoAiAgentId: string;
  state: JiraAgentSessionState;
};
export type JiraAssetFieldInput = {
  assets: ReadonlyArray<JiraAssetInput>;
  fieldId: string;
};
export type JiraAssetInput = {
  appKey: string;
  originId: string;
  serializedOrigin: string;
  value: string;
};
export type JiraAtlassianTeamFieldInput = {
  fieldId: string;
  team: JiraAtlassianTeamInput;
};
export type JiraAtlassianTeamInput = {
  teamId: string;
};
export type JiraCascadingSelectFieldInput = {
  childOptionValue?: JiraSelectedOptionInput | null;
  fieldId: string;
  parentOptionValue: JiraSelectedOptionInput;
};
export type JiraSelectedOptionInput = {
  id?: string | null;
  optionId?: string | null;
};
export type JiraClearableNumberFieldInput = {
  fieldId: string;
  value?: number | null;
};
export type JiraCMDBFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null;
  cmdbObjects: ReadonlyArray<JiraCMDBInput>;
  fieldId: string;
};
export type JiraCMDBInput = {
  cmdbObjectGlobalId: string;
};
export type JiraColorFieldInput = {
  color: JiraColorInput;
  fieldId: string;
};
export type JiraColorInput = {
  name: string;
};
export type JiraDateFieldInput = {
  date: JiraDateInput;
  fieldId: string;
};
export type JiraDateInput = {
  formattedDate: string;
};
export type JiraDateTimeFieldInput = {
  dateTime: JiraDateTimeInput;
  fieldId: string;
};
export type JiraDateTimeInput = {
  formattedDateTime: string;
};
export type JiraEntitlementFieldInput = {
  entitlement: JiraEntitlementInput;
  fieldId: string;
};
export type JiraEntitlementInput = {
  entitlementId: string;
};
export type JiraEpicLinkFieldInput = {
  epicLink: JiraEpicLinkInput;
  fieldId: string;
};
export type JiraEpicLinkInput = {
  issueKey: string;
};
export type JiraIssueLinksFieldInput = {
  direction?: JiraIssueLinkDirection | null;
  linkTypeId?: string | null;
  linkTypeName?: string | null;
  linkedIssueKeys?: ReadonlyArray<string> | null;
  operation?: JiraBulkLinkEditOperation | null;
};
export type JiraForgeGroupsFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null;
  fieldId: string;
  selectedGroups: ReadonlyArray<JiraGroupInput>;
};
export type JiraGroupInput = {
  groupName: string;
};
export type JiraForgeStringsFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null;
  fieldId: string;
  labels: ReadonlyArray<JiraLabelsInput>;
};
export type JiraLabelsInput = {
  name?: string | null;
};
export type JiraForgeUsersFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null;
  fieldId: string;
  users: ReadonlyArray<JiraUserInput>;
};
export type JiraUserInput = {
  accountId: string;
};
export type JiraLabelsFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null;
  fieldId: string;
  labels?: ReadonlyArray<JiraLabelsInput> | null;
};
export type JiraSingleLineTextFieldInput = {
  fieldId: string;
  text?: string | null;
};
export type JiraMultipleGroupPickerFieldInput = {
  fieldId: string;
  groups: ReadonlyArray<JiraGroupInput>;
};
export type JiraMultipleSelectClearableUserPickerFieldInput = {
  fieldId: string;
  users?: ReadonlyArray<JiraUserInput> | null;
};
export type JiraMultipleSelectFieldInput = {
  fieldId: string;
  options: ReadonlyArray<JiraSelectedOptionInput>;
};
export type JiraMultipleSelectUserPickerFieldInput = {
  fieldId: string;
  users: ReadonlyArray<JiraUserInput>;
};
export type JiraMultipleVersionPickerFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null;
  fieldId: string;
  versions: ReadonlyArray<JiraVersionInput>;
};
export type JiraVersionInput = {
  versionId?: string | null;
};
export type JiraMultiSelectComponentFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null;
  components?: ReadonlyArray<JiraComponentInput> | null;
  fieldId: string;
};
export type JiraComponentInput = {
  componentId: string;
};
export type JiraNumberFieldInput = {
  fieldId: string;
  value: number;
};
export type JiraOrganizationFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null;
  fieldId: string;
  organizations: ReadonlyArray<JiraOrganizationsInput>;
};
export type JiraOrganizationsInput = {
  organizationId: string;
};
export type JiraDurationFieldInput = {
  originalEstimateField?: string | null;
};
export type JiraParentFieldInput = {
  issueId: string;
};
export type JiraPeopleFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null;
  fieldId: string;
  users: ReadonlyArray<JiraUserInput>;
};
export type JiraPriorityInput = {
  priorityId: string;
};
export type JiraProjectFieldInput = {
  fieldId: string;
  project: JiraProjectInput;
};
export type JiraResolutionInput = {
  resolutionId: string;
};
export type JiraServiceManagementRespondersFieldInput = {
  bulkEditMultiSelectFieldOption?: JiraBulkEditMultiSelectFieldOptions | null;
  fieldId: string;
  responders: ReadonlyArray<JiraServiceManagementResponderFieldInput>;
};
export type JiraServiceManagementResponderFieldInput = {
  responderId: string;
};
export type JiraRichTextFieldInput = {
  fieldId: string;
  richText: JiraRichTextInput;
};
export type JiraRichTextInput = {
  adfValue?: AGG$JSON | null;
  wikiText?: string | null;
};
export type JiraSecurityLevelInput = {
  securityLevelId: string;
};
export type JiraSingleGroupPickerFieldInput = {
  fieldId: string;
  group: JiraGroupInput;
};
export type JiraSingleOrganizationFieldInput = {
  fieldId: string;
  organization: JiraOrganizationsInput;
};
export type JiraUserFieldInput = {
  fieldId: string;
  user?: JiraUserInput | null;
};
export type JiraSingleSelectFieldInput = {
  fieldId: string;
  option: JiraSelectedOptionInput;
};
export type JiraSingleSelectUserPickerFieldInput = {
  fieldId: string;
  user: JiraUserInput;
};
export type JiraSingleVersionPickerFieldInput = {
  fieldId: string;
  version: JiraVersionInput;
};
export type JiraSprintFieldInput = {
  fieldId: string;
  sprints: ReadonlyArray<JiraSprintInput>;
};
export type JiraSprintInput = {
  sprintId: string;
};
export type JiraStatusInput = {
  statusId: string;
};
export type JiraTeamFieldInput = {
  fieldId: string;
  team: JiraTeamInput;
};
export type JiraTeamInput = {
  teamId: string;
};
export type JiraTimeTrackingFieldInput = {
  originalEstimate?: string | null;
  timeRemaining?: string | null;
};
export type JiraUrlFieldInput = {
  fieldId: string;
  url: string;
};
export type IssueCreateModalLoadQuery$variables = {
  cloudId: string;
  defaultValues?: JiraIssueFieldsInput | null;
  evaluateMiniMode?: boolean | null;
  issueType?: JiraIssueTypeInput | null;
  project?: JiraProjectInput | null;
  requestType?: JiraRequestTypeInput | null;
};
export type IssueCreateModalLoadQuery$data = {
  readonly issueCreateFields: {
    readonly __typename: "JiraIssueCreateFields";
    readonly fields: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly fieldId: string;
          readonly name: string;
          readonly " $fragmentSpreads": FragmentRefs<"IssueCreateRelayFieldRenderer_field">;
        } | null;
      } | null> | null;
    } | null;
    readonly jiraIssueCreateFieldsFragment: {
      readonly " $fragmentSpreads": FragmentRefs<"IssueCreateRelayFormWrapper_createFields">;
    } | null;
  } | {
    readonly __typename: "QueryError";
    readonly message: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type IssueCreateModalLoadQuery = {
  response: IssueCreateModalLoadQuery$data;
  variables: IssueCreateModalLoadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "defaultValues"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "evaluateMiniMode"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "project"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requestType"
},
v6 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "defaultValues",
    "variableName": "defaultValues"
  },
  {
    "kind": "Variable",
    "name": "evaluateMiniMode",
    "variableName": "evaluateMiniMode"
  },
  {
    "kind": "Literal",
    "name": "fieldsFilter",
    "value": "USER_CONFIGURED_FIELDS"
  },
  {
    "kind": "Variable",
    "name": "issueType",
    "variableName": "issueType"
  },
  {
    "kind": "Variable",
    "name": "project",
    "variableName": "project"
  },
  {
    "kind": "Variable",
    "name": "requestType",
    "variableName": "requestType"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = [
  {
    "kind": "ScalarField",
    "name": "message"
  }
],
v9 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "QueryError"
},
v10 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = {
  "kind": "ScalarField",
  "name": "type"
},
v14 = {
  "kind": "ScalarField",
  "name": "description"
},
v15 = {
  "kind": "ScalarField",
  "name": "number"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        },
        {
          "concreteType": "JiraFieldNonEditableReason",
          "kind": "LinkedField",
          "name": "nonEditableReason",
          "plural": false,
          "selections": (v8/*: any*/)
        }
      ]
    }
  ],
  "type": "JiraIssueFieldConfiguration",
  "abstractKey": "__isJiraIssueFieldConfiguration"
},
v17 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/)
],
v18 = [
  (v13/*: any*/),
  (v14/*: any*/),
  {
    "kind": "ScalarField",
    "name": "text"
  },
  (v16/*: any*/)
],
v19 = [
  {
    "kind": "ScalarField",
    "name": "priorityId"
  },
  (v11/*: any*/),
  {
    "kind": "ScalarField",
    "name": "iconUrl"
  },
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "IssueCreateModalLoadQuery",
    "selections": [
      {
        "alias": "issueCreateFields",
        "args": (v6/*: any*/),
        "kind": "LinkedField",
        "name": "jira_issueCreateFields",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "fragment": {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "IssueCreateRelayFormWrapper_createFields"
                    }
                  ],
                  "type": "JiraIssueCreateFields"
                },
                "kind": "AliasedInlineFragmentSpread",
                "name": "jiraIssueCreateFieldsFragment"
              },
              {
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fields",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          {
                            "kind": "FragmentSpread",
                            "name": "IssueCreateRelayFieldRenderer_field"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraIssueCreateFields"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "IssueCreateModalLoadQuery",
    "selections": [
      {
        "alias": "issueCreateFields",
        "args": (v6/*: any*/),
        "kind": "LinkedField",
        "name": "jira_issueCreateFields",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "JiraIssueFieldConnection",
                "kind": "LinkedField",
                "name": "fields",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v10/*: any*/),
                          (v12/*: any*/),
                          (v11/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isJiraIssueField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraFieldConfig",
                                "kind": "LinkedField",
                                "name": "fieldConfig",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "isRequired"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraIssueFieldConfiguration",
                            "abstractKey": "__isJiraIssueFieldConfiguration"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraNumberFieldFormatConfig",
                                "kind": "LinkedField",
                                "name": "formatConfig",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "formatStyle"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "formatUnit"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "formatDecimals"
                                  }
                                ]
                              },
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/)
                            ],
                            "type": "JiraNumberField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v17/*: any*/),
                            "type": "JiraConnectNumberField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v18/*: any*/),
                            "type": "JiraConnectTextField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "date"
                              },
                              (v16/*: any*/)
                            ],
                            "type": "JiraDatePickerField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "dateTime"
                              },
                              (v16/*: any*/)
                            ],
                            "type": "JiraDateTimePickerField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v17/*: any*/),
                            "type": "JiraForgeNumberField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v18/*: any*/),
                            "type": "JiraForgeStringField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              {
                                "concreteType": "JiraPriority",
                                "kind": "LinkedField",
                                "name": "priority",
                                "plural": false,
                                "selections": (v19/*: any*/)
                              },
                              {
                                "concreteType": "JiraPriorityConnection",
                                "kind": "LinkedField",
                                "name": "priorities",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "JiraPriorityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraPriority",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": (v19/*: any*/)
                                      }
                                    ]
                                  }
                                ]
                              },
                              (v16/*: any*/)
                            ],
                            "type": "JiraPriorityField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v18/*: any*/),
                            "type": "JiraSingleLineTextField"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v13/*: any*/),
                              (v14/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              },
                              (v16/*: any*/)
                            ],
                            "type": "JiraUrlField"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraIssueCreateFields"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0c7fed0f55d7c7a558f04463a5b6ab21494ed602ead3e9325a3632f2ba811087",
    "metadata": {},
    "name": "IssueCreateModalLoadQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "75fb37a97af08a24b783c6d732838199";

export default node;
